import { render, staticRenderFns } from "./unionPriceLevel.vue?vue&type=template&id=42553541&scoped=true&"
import script from "./unionPriceLevel.vue?vue&type=script&lang=js&"
export * from "./unionPriceLevel.vue?vue&type=script&lang=js&"
import style0 from "./unionPriceLevel.vue?vue&type=style&index=0&id=42553541&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42553541",
  null
  
)

component.options.__file = "unionPriceLevel.vue"
export default component.exports